import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const PreviewScheduledContentModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "PreviewScheduledContentModalContainer" */
      './PreviewScheduledContentModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
